import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Wave } from "./Wave";

export const LegalLayout = ({ title, children }) => (
    <div className="min-h-screen bg-carbone text-avorio">
        <header className="border-b border-bordo">
            <div className="container-pub h-[72px] flex items-center justify-between">
                <Link to="/" className="flex items-center gap-3 leading-none" data-testid="legal-logo">
                    <img
                        src="/images/logo-river-pub.png"
                        alt="Logo River Pub"
                        width={44}
                        height={44}
                        className="h-11 w-11 rounded-full"
                    />
                    <span className="flex flex-col items-start leading-none">
                        <span className="font-heading font-semibold uppercase text-xl tracking-[0.22em]">
                            River Pub
                        </span>
                        <Wave className="w-12 h-2.5 mt-1 text-ambra" />
                    </span>
                </Link>
                <Link to="/" className="btn btn-outline !min-h-0 !py-2" data-testid="legal-back-link">
                    <ArrowLeft className="w-4 h-4" /> Torna al sito
                </Link>
            </div>
        </header>
        <main className="container-pub py-14">
            <h1 className="font-heading font-semibold uppercase tracking-wide text-3xl sm:text-4xl">{title}</h1>
            <div className="legal-prose mt-6 max-w-3xl">{children}</div>
        </main>
        <footer className="border-t border-bordo">
            <div className="container-pub py-6 text-xs text-avorio/60">
                © {new Date().getFullYear()} River Pub di Giuntini Andrea F. &amp; C. sas
            </div>
        </footer>
    </div>
);